import SiteLayout from "@/components/feature/SiteLayout";
import Hero from "./components/Hero";
import Philosophy from "./components/Philosophy";
import Programs from "./components/Programs";
import Transformations from "./components/Transformations";
import StudioStrip from "./components/StudioStrip";
import Testimonials from "./components/Testimonials";
import CTA from "./components/CTA";

export default function Home() {
  return (
    <SiteLayout navbarVariant="overlay">
      <Hero />
      <Philosophy />
      <Programs />
      <Transformations />
      <StudioStrip />
      <Testimonials />
      <CTA />
    </SiteLayout>
  );
}